import {Component, OnInit, TemplateRef} from '@angular/core';
import {NgbDate, NgbDateStruct, NgbModal, NgbModalConfig} from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import {FieldErrorDisplayComponent} from '../field-error-display/field-error-display.component';
import {NotificationsService} from '../../../services/notifications.service';
import {IAddress} from '../../../domain/IAddress';
import {EOperationType} from '../../../enums/EOperationType';
import {AccountStatus} from '../../../domain/accounts/account';
import {MediaAccessStatus, MediaAccessType} from '../../../domain/accounts/media-access';
import {ETargetAccountStatus} from '../../../enums/ETargetAccountStatus';
import {ETargetAccountType} from '../../../enums/ETargetAccountType';
import {ToastaService} from 'ngx-toasta';
import {environment} from '../../../../environments/environment';
import {Router} from '@angular/router';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {TimeoutError} from 'rxjs';
import {EKycStatus} from '../../../enums/EKycStatus';
import {CountryCode, PhoneCountries} from '../../../entity/CountryCodeEntity';
import {ApplicationStatus} from '../../../domain/onBoarding/application-body';
import {MovementType} from '../../../domain/accounts/movement';
import {CustomerStatus} from '../../../domain/customer/customer-detail';
import {DialogService, DynamicDialogRef} from 'primeng/dynamicdialog';
import {Application} from '../../../domain/onBoarding/application';
import {ApplicationConfiguration} from '../../../domain/configurations';

export enum ModalSize {SM = 'sm', MD = '', LG = 'lg', XL = 'xl'}

@Component({
  selector: 'app-modal-content',
  template: `
    <p-progressSpinner></p-progressSpinner>
    <p class='m-0' i18n='@@loadingModal' *ngIf='useOldTranslation()'>Cargando...</p>
    <p class='m-0' *ngIf='!useOldTranslation()' translate>{{ 'shared.common.loadingModal' | translate: {Default: 'Cargando...'} }}</p>
  `
})
export class ModalContentComponent {
  constructor(
    protected router: Router,
    public translate: TranslateService
  ) {
    }

  useOldTranslation() {
    if (this.router.url.includes('personalData') || this.router.url.includes('broker') || this.router.url.includes('photos') ||
      this.router.url.includes('additionalIdentification') || this.router.url.includes('additionalQuestions') || this.router.url.includes('preApproved') ||
      this.router.url.includes('contracts') || this.router.url.includes('referred') || this.router.url.includes('usaIds') ||
      this.router.url.includes('signature') || this.router.url.includes('contactData') ||
      this.router.url.includes('end') || this.router.url.includes('selfie')) {
      return false;
    } else {
      return true;
    }
  }
}

@Component({
  selector: 'app-common',
  templateUrl: './common.component.html',
  styleUrls: ['./common.component.scss'],
  providers: [NgbModalConfig, NgbModal]
})
export class CommonComponent extends FieldErrorDisplayComponent implements OnInit {
  eOperationType = EOperationType;
  accountStatus = AccountStatus;
  eMediaAccessStatus = MediaAccessStatus;
  eMediaAccessType = MediaAccessType;
  eMovementType = MovementType;
  eTargetAccountStatus = ETargetAccountStatus;
  eTargetAccountTypes = ETargetAccountType;
  eApplicationStatusType = ApplicationStatus;
  eKycStatusType = EKycStatus;
  ePhoneCountries = PhoneCountries;
  eModalSize = ModalSize;
  eCustomerStatus = CustomerStatus;
  productName = environment.productName;
  msgTimeout = 10000;
  modalRef: DynamicDialogRef;

  constructor(
    protected modalService: NgbModal,
    protected notificationsService: NotificationsService,
    protected toastService: ToastaService,
    protected router: Router,
    public translate: TranslateService,
    protected dialogService: DialogService
  ) {
    super(router, translate);
  }

  ngOnInit(): void {
  }

  loadingModalOn(): void {
    this.modalRef = this.dialogService.open(ModalContentComponent, {
      baseZIndex: 10000,
      closable: false,
      modal: true
    });
  }

  loadingModalOff(): void {
    this.dialogService.dialogComponentRefMap.forEach(dialog => {
      dialog.destroy();
    });
  }

  openModal(content: TemplateRef<any>, modalSize: ModalSize = ModalSize.SM): void {
    this.modalService.open(content, {
      size: modalSize,
      centered: true,
      backdrop: 'static',
      keyboard: false
    });
  }

  // TODO esto suena a que no se necesita
  formatNgbDate(date): NgbDate {
    const Day = moment(date, 'YYYY/MM/DD').format('DD');
    const Month = moment(date, 'YYYY/MM/DD').format('MM');
    const Year = moment(date, 'YYYY/MM/DD').format('YYYY');
    return new NgbDate(+Year, +Month, +Day);
  }

  formatDate(date: NgbDateStruct): string {
    if (date) {
      const jsDate = new Date(date.year, date.month - 1, date.day);
      return moment(jsDate).format('YYYY-MM-DD');
    } else {
      return null;
    }
  }

  getMsg() {
    return this.notificationsService.msgs;
  }

  msgSuccess(message, message2?): void {
    const translation: string = this.useOldTranslation() ? $localize`:@@notifications_success:Listo`
      : this.translate.instant('shared.common.notifications_success', {Default: 'Listo'});
    this.toastService.success({
      title: translation,
      showDuration: true,
      timeout: this.msgTimeout,
      msg: `${message} ${message2 ? ' ' + message2 : ''}`
    });
  }

  msgInfo(message, message2?): void {
    this.toastService.info({
      title: this.useOldTranslation() ?
        $localize`:@@notifications_info:Aviso`
        : this.translate.instant('shared.common.notifications_info', {Default: 'Aviso'}),
      showDuration: true,
      timeout: this.msgTimeout,
      msg: `${message} ${message2 ? ' ' + message2 : ''}`
    });
  }

  msgWarning(message, message2?): void {
    this.toastService.warning({
      title: this.useOldTranslation() ?
        $localize`:@@notifications_warning:Advertencia`
        : this.translate.instant('shared.common.notifications_warning', {Default: 'Advertencia'}),
      showDuration: true,
      timeout: this.msgTimeout,
      msg: `${message} ${message2 ? ' ' + message2 : ''}`
    });
  }

  msgError(error, msg?) {
// TODO arreglar esta funcionalidad
    let dataArray;
    switch (error.status) {
      case 400:
        dataArray = error.error.errors;
        if (dataArray) {
          for (const err of dataArray) {
            this.toastService.error({
              title: 'Error ' + error.status,
              msg: `${err.defaultMessage} ${msg ? ' ' + msg : ''}`,
              showClose: true,
              timeout: this.msgTimeout
            });
          }
        } else {
          this.toastService.error({
            title: 'Error ' + error.status,
            msg: `${error.error.message} ${msg ? ' ' + msg : ''}`,
            showClose: true,
            timeout: this.msgTimeout
          });
        }
        break;
      case 401:
        this.toastService.error({
          title: 'Error ' + error.status,
          msg: `${error.error.message ? error.error.message : error.message} ${msg ? ', ' + msg : ''}`,
          showClose: true,
          timeout: this.msgTimeout
        });
        break;
      case 403:
        this.toastService.error({
          title: 'Error ' + error.status,
          msg: msg ? msg : error.message,
          showClose: true,
          timeout: this.msgTimeout
        });
        break;
      case 404:
        this.toastService.error({
          title: 'Error ' + error.status,
          msg: this.useOldTranslation() ?
            $localize`:@@shared_common-component.resourceNotFoundError:No encontramos la consulta que desea realizar, verifique y vuelva a intentarlo`
            : this.translate.instant('shared.common.resourceNotFoundError', {Default: 'No encontramos la consulta que desea realizar, verifique y vuelva a intentarlo.'}),
          showClose: true,
          timeout: this.msgTimeout
        });
        break;
      case 409:
        this.toastService.error({
          title: 'Error ' + error.status,
          msg: `${error.error.message ? error.error.message : error.message} ${msg ? ', ' + msg : ''}`,
          showClose: true,
          timeout: this.msgTimeout
        });
        break;
      case 418:
        this.toastService.error({
          title: 'Error 401',
          msg: this.useOldTranslation() ?
            $localize`:@@session_expired:La sesión expiró. Por favor, vuelve a iniciar sesión.`
            : this.translate.instant('shared.common.session_expired', {Default: 'La sesión expiró. Por favor, vuelve a iniciar sesión.'}),
          showClose: true,
          timeout: this.msgTimeout
        });
        break;
      case 422:
        dataArray = error.error.errors;
        for (const err of dataArray) {
          this.toastService.error({
            title: 'Error ' + error.status,
            msg: `${err.defaultMessage ? err.defaultMessage : error.error.message ? error.error.message : error.message} ${msg ? ', ' + msg : ''}`,
            showClose: true,
            timeout: this.msgTimeout
          });
        }
        break;
      default:
        if (error instanceof TimeoutError) {
          this.toastService.error({
            title: 'Error',
            msg: msg ? msg : this.useOldTranslation() ?
              $localize`:@@shared_common.timeoutError:El servicio no responde`
              : this.translate.instant('shared.common.timeoutError', {Default: 'El servicio no responde'}),
            showClose: true,
            timeout: this.msgTimeout
          });
        } else {
          this.toastService.error({
            title: 'Error',
            msg: msg ? msg : this.useOldTranslation() ?
              $localize`:@@shared_common.generalErrorMessage:Ocurrió un error con tu solicitud`
              : this.translate.instant('shared.common.general_error_message', {Default: 'Ocurrió un error con tu solicitud'}),
            showClose: true,
            timeout: this.msgTimeout
          });
        }
    }
  }

  msgReset() {
    this.notificationsService.msgs = [];
    this.notificationsService.cardActivationMsgPush = false;
    this.notificationsService.accountStatusMsgPush = false;
  }

  closeNotification(index: number) {
    this.notificationsService.msgs.splice(index, 1);
  }

  reformatPostalCode(postalCodeData) {
    let add: IAddress;
    add = {
      state: [],
      suburb: [],
      town: [],
      city: []
    };

    if (postalCodeData.estadoDetalle) {
      add.state.push({
        id: postalCodeData.estadoDetalle.cve_estado,
        value: postalCodeData.estadoDetalle.des_estado,
      });
    }

    if (postalCodeData.coloniasDetalle) {
      for (const c of postalCodeData.coloniasDetalle) {
        add.city.push({id: c.cve_colonia, value: c.des_colonia});
      }
    }

    if (postalCodeData.municipio) {
      add.town.push({id: postalCodeData.cve_municipio, value: postalCodeData.municipio});
    }
    /*
        if (postalCodeData.ciudadDetalle) {
          add.city.push({id: postalCodeData.ciudadDetalle.cve_ciudad, value: postalCodeData.ciudadDetalle.des_ciudad});
        }*/
    return add;
  }

  passwordSequencesValidation(password: string) {
    if (password) {
      const textList = password.toLowerCase().split('');
      const alphabet = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
      const numerics = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
      let result = true;
      for (let i = 0; i < textList.length - 2; i++) {
        let num;
        let alp;
        alp = alphabet.find((element) => element === textList[i]);
        num = numerics.find((element) => element === textList[i]);

        let index;
        const next = textList[i + 1];

        if (alp) {
          index = alphabet.indexOf(alp);
          if (index <= alphabet.length - 3 && (next === (alphabet[index + 1]))) {
            if (textList[i + 2] === alphabet[index + 2]) {
              result = false;
              break;
            }
          }
          if (index >= 2 && (next === (alphabet[index - 1]))) {
            if (textList[i + 2] === alphabet[index - 2]) {
              result = false;
              break;
            }
          }
        }
        if (num) {
          index = numerics.indexOf(num);
          if (index <= numerics.length - 3 && (next === (numerics[index + 1]))) {
            if (textList[i + 2] === numerics[index + 2]) {
              result = false;
              break;
            }
          }
          if (index >= 2 && (next === (numerics[index - 1]))) {
            if (textList[i + 2] === numerics[index - 2]) {
              result = false;
              break;
            }
          }
        }
      }
      return result;
    }
    return false;
  }

  passwordRepetitionValidation(password: string) {
    password = password.toLowerCase();
    const passwordLetters = [];
    let reps = false;
    for (let i = 0; i < password.length; i++) {
      passwordLetters.push(password[i].charCodeAt(0));
      if (i > 1) {
        if ((passwordLetters[i - 2] === passwordLetters[i] && passwordLetters[i - 1] === passwordLetters[i])) {
          reps = true;
        }
      }
    }
    return reps;
  }

  passwordSpacesValidation(password: string) {
    const regex = new RegExp(/^\S*$/);
    return regex.test(password);
  }

  passwordCapsValidation(password: string) {
    const regex = new RegExp(/^(.*[A-Z].*)$/);
    return regex.test(password);
  }

  passwordLowerCaseValidation(password: string) {
    const regex = new RegExp(/^(.*[a-z].*)$/);
    return regex.test(password);
  }

  passwordNumberValidation(password: string) {
    const regex = new RegExp(/^(.*\d.*)$/);
    return regex.test(password);
  }

  passwordSpecialValidation(password: string) {
    const regex = new RegExp(/[^a-zA-Z0-9 ]/);
    return regex.test(password);
  }

  useOldTranslation() {
    if (this.router.url.includes('personalData') || this.router.url.includes('broker') || this.router.url.includes('photos') ||
      this.router.url.includes('additionalIdentification') || this.router.url.includes('additionalQuestions') || this.router.url.includes('preApproved') ||
      this.router.url.includes('contracts') || this.router.url.includes('referred') || this.router.url.includes('usaIds') ||
      this.router.url.includes('signature') || this.router.url.includes('contactData') || this.router.url.includes('transactionHistory') ||
      this.router.url.includes('end') || this.router.url.includes('selfie') || this.router.url.includes('transfers')) {
      return false;
    } else {
      return true;
    }
  }

  cardActivationMessage() {
    const translation: string = this.useOldTranslation() ? $localize`:@@notifications_warning:Advertencia`
      : this.translate.instant('shared.common.notifications_warning', {Default: 'Advertencia'});
    const translation2: string = this.useOldTranslation() ? $localize`:@@balance_inactiveCardMessage:Tu tarjeta está desactivada por favor actívala llamando al call center (888)877-2268.`
      : this.translate.instant('shared.common.cardActivation_message', {Default: `Tu tarjeta está desactivada por favor actívala llamando al call center (888)877-2268.`});
    if (!this.notificationsService.cardActivationMsgPush) {
      this.notificationsService.msgs.push({
        title: translation,
        dateCreated: new Date(),
        description: translation2,
        icon: 'fas fa-exclamation-triangle',
        color: 'warning',
        button: true
      });
      this.notificationsService.cardActivationMsgPush = true;
    }
  }

  applicationRejectedMessage() {
    const translation: string = this.useOldTranslation() ? $localize`:@@notifications_applicationRejected:Aplicación rechazada`
      : this.translate.instant('shared.common.notifications_applicationRejected', {Default: 'Aplicación rechazada'});
    const translation2: string = this.useOldTranslation() ? $localize`:@@notifications_applicationRejectedBody:Tu aplicación ha sido rechazada, por favor verifica tu correo electrónico para tener más detalle del rechazo.`
      : this.translate.instant('shared.common.notifications_applicationRejectedBody', {Default: 'Tu aplicación ha sido rechazada, por favor verifica tu correo electrónico para tener más detalle del rechazo.'});
    if (!this.notificationsService.accountStatusMsgPush) {
      this.notificationsService.msgs.push({
        title: translation,
        dateCreated: new Date(),
        description: translation2,
        icon: 'fas fa-exclamation-circle',
        color: 'danger'
      });
      this.notificationsService.accountStatusMsgPush = true;
    }
  }

  accountPendingMessage() {
    const translation2: string = this.useOldTranslation() ? $localize`:@@notifications_accountPendingMessage:Tu cuenta aún está en proceso de verificación. Por lo que algunas opciones aún no están habilitadas, en cuanto el proceso finalice se activaran todas las opciones.`
      : this.translate.instant('shared.common.notifications_accountPendingMessage', {Default: 'Tu cuenta aún está en proceso de verificación. Por lo que algunas opciones aún no están habilitadas, en cuanto el proceso finalice se activaran todas las opciones.'});
    if (!this.notificationsService.accountStatusMsgPush) {
      this.notificationsService.msgs.push({
        title: '',
        dateCreated: new Date(),
        description: translation2,
        icon: 'fas fa-exclamation-circle',
        color: 'info'
      });
      this.notificationsService.accountStatusMsgPush = true;
    }
  }

  getCountryPhoneData(phoneCountry: PhoneCountries = PhoneCountries.USA, applicationConfiguration: ApplicationConfiguration): CountryCode {
    let countryCode: CountryCode;
    this.countryCodeCatalog(applicationConfiguration).forEach(function callback(element) {
      if (element.country === phoneCountry) {
        countryCode = element;
      }
    });
    return countryCode;
  }

  getDialCodePhoneData(dialCode: string = '1', applicationConfiguration: ApplicationConfiguration): CountryCode {
    let countryCode: CountryCode;
    this.countryCodeCatalog(applicationConfiguration).forEach(function callback(element) {
      if (element.dialCode === dialCode) {
        countryCode = element;
      }
    });
    return countryCode;
  }

  countryCodeCatalog(applicationConfiguration: ApplicationConfiguration): CountryCode[] {
    const data: CountryCode[] = [
      {
        active: applicationConfiguration.enablePhoneUsa,
        dialCode: '1',
        mask: '(000) 000-0000',
        flag: '/assets/flags/flags_USA.png',
        country: PhoneCountries.USA,
        name:  this.translate.instant('shared.common.usa', {Default: 'Estados Unidos'}),
        digits: 10
      },
      {
        active: applicationConfiguration.enablePhoneMex,
        dialCode: '52',
        mask: '(00) 0000 0000',
        flag: '/assets/flags/flags_MEX.png',
        country: PhoneCountries.MEX,
        name: this.translate.instant('shared.common.mex', {Default: 'México'}),
        digits: 10
      },
      {
        active: applicationConfiguration.enablePhoneGtm,
        dialCode: '502',
        mask: '0000-0000',
        flag: '/assets/flags/flags_GTM.png',
        country: PhoneCountries.GTM,
        name: this.translate.instant('shared.common.gtm', {Default: 'Guatemala'}),
        digits: 8
      },
      {
        active: applicationConfiguration.enablePhoneEcu,
        dialCode: '593',
        mask: '00 00 000-000',
        flag: '/assets/flags/flags_ECU.png',
        country: PhoneCountries.ECU,
        name: this.translate.instant('shared.common.ecu', {Default: 'Ecuador'}),
        digits: 10
      },
      {
        active: applicationConfiguration.enablePhoneSlv,
        dialCode: '503',
        mask: '0000-0000',
        flag: '/assets/flags/flags_SLV.png',
        country: PhoneCountries.SLV,
        name: this.translate.instant('shared.common.slv', {Default: 'El Salvador'}),
        digits: 8
      }
    ];

    const countryCodes: CountryCode[] = [];
    data.forEach(function callback(element) {
      if (element.active) {
        countryCodes.push(element);
      }
    });
    return countryCodes;
  }
  isNullOrTrue(data: undefined | null | boolean): boolean {
    return data === undefined || data === null || data === true;
  }

  isAmericanCitizen(application: Application) {
    if (application.body.socialSecurityNumber && ((!application.body?.identificationCountry && !application.body?.identification2Country)
      || (application.body?.documents?.length && application.body?.documents?.length <= 1))) {
      return true;
    }
    return false;
  }
  getValidLanguage(language: string){
    if (language === 'es' || language === 'en'){
      return language;
    } else {
      return 'en';
    }
  }

  getCurrentPosition(): Promise<any> {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resp => {
          resolve({lng: resp.coords.longitude, lat: resp.coords.latitude});
        },
        err => {
          reject(err);
        });
    });

  }



}
